import apiCore from '../../utils/api-core';

export function getEmailLog(params) {
    return apiCore.get('/api/v3/email-log', { params });
}
